import * as angular from 'angular';
import { ImSchool } from 'Src/ng2/shared/services/im-models/im-school';
import nvSharedModelsModule from '../nv.shared.models.module';

angular
  .module(nvSharedModelsModule)
  .factory('Notification', (NvBaseModel, ImSchool: ImSchool, UtilitiesService, PublicConfig, $http) => {
    const PERMISSIONING_MODEL_NAME = 'NOTIFICATION';
    const relationToUserPath = 'createdBy.userId';

    let Notification = NvBaseModel(
      '/v1/notifications/:id',
      { id: '@_id' },
      {
        query: {
          url: PublicConfig.NV_API_ORIGIN + '/v1/notifications',
          method: 'GET',
          isArray: true,
        },
      },
      null,
      PERMISSIONING_MODEL_NAME,
      relationToUserPath,
    );

    Notification.getNotificationsForUser = () => {
      return Notification.query({ status: 'ACTIVE' });
    };

    Notification.singleUpdate = (id, path, newValue) => {
      const patch = UtilitiesService.setFieldByPath({}, path, newValue);
      return $http.patch(PublicConfig.NV_API_ORIGIN + '/v1/notifications/' + id, patch);
    };

    Notification.extend({
      // PATCHES
      dismiss(userId: string): void {
        const obj = {};
        obj[userId] = true;
        return Notification.singleUpdate(this._id, `dismissals`, obj);
      },

      deactivate(): void {
        return Notification.singleUpdate(this._id, 'status', 'NOT_ACTIVE');
      },
    });

    return Notification;
  });
